// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.6.8_@swc+helpers@0.5.23__webpack@5.108.4_@swc+core@1.15_b0345aabf8a2fe8f5423f3b3e9febcd5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.6.8_@swc+helpers@0.5.23__webpack@5.108.4_@swc+core@1.15_b0345aabf8a2fe8f5423f3b3e9febcd5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pg7yhRjb__RegistrationFormController__styles-module__button___rvuIeIu3rhYQWaph {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
}

.pg7yhRjb__RegistrationFormController__styles-module__banner___kWaRzaDnhwkQYLaD {
    width: 100%;
}

.pg7yhRjb__RegistrationFormController__styles-module__form___sO6r1WsUTMvlp5IN {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.pg7yhRjb__RegistrationFormController__styles-module__or___wyI44BlmNws4nZ8P {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    color: var(--ds-color-text-secondary);
    text-align: center;
}


.pg7yhRjb__RegistrationFormController__styles-module__or___wyI44BlmNws4nZ8P::before, .pg7yhRjb__RegistrationFormController__styles-module__or___wyI44BlmNws4nZ8P::after {
    content: "";
    flex: 1 1;
    height: 1px;
    background: var(--ds-color-border-soft);
}

.pg7yhRjb__RegistrationFormController__styles-module__googleFooter___t8jcEU1X5Vk9QfyG {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
}

.pg7yhRjb__RegistrationFormController__styles-module__googleFooterDivider___WQFQOxbJrKE1tu_Y {
    width: 1px;
    height: 1rem;
    background: var(--ds-color-border-soft);
}
`, "",{"version":3,"sources":["webpack://./src/modules/registrationForm/components/RegistrationFormController/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qCAAqC;IACrC,kBAAkB;AACtB;;;AAGA;IACI,WAAW;IACX,SAAO;IACP,WAAW;IACX,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,uCAAuC;AAC3C","sourcesContent":[".button {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    align-items: center;\n}\n\n.banner {\n    width: 100%;\n}\n\n.form {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.or {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n    color: var(--ds-color-text-secondary);\n    text-align: center;\n}\n\n\n.or::before, .or::after {\n    content: \"\";\n    flex: 1;\n    height: 1px;\n    background: var(--ds-color-border-soft);\n}\n\n.googleFooter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.75rem;\n}\n\n.googleFooterDivider {\n    width: 1px;\n    height: 1rem;\n    background: var(--ds-color-border-soft);\n}\n"],"sourceRoot":""}]);
// Exports
export var button = `pg7yhRjb__RegistrationFormController__styles-module__button___rvuIeIu3rhYQWaph`;
export var banner = `pg7yhRjb__RegistrationFormController__styles-module__banner___kWaRzaDnhwkQYLaD`;
export var form = `pg7yhRjb__RegistrationFormController__styles-module__form___sO6r1WsUTMvlp5IN`;
export var or = `pg7yhRjb__RegistrationFormController__styles-module__or___wyI44BlmNws4nZ8P`;
export var googleFooter = `pg7yhRjb__RegistrationFormController__styles-module__googleFooter___t8jcEU1X5Vk9QfyG`;
export var googleFooterDivider = `pg7yhRjb__RegistrationFormController__styles-module__googleFooterDivider___WQFQOxbJrKE1tu_Y`;
export default ___CSS_LOADER_EXPORT___;
